const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const dateFormat = (dateValue, fullName = true, monthDay = false) => {
  let dateString = dateValue

  if (typeof dateString === 'string') {
    dateString = dateString.replace(/\s/, 'T')
  }

  if (!dateString) {
    return ''
  }

  const date = new Date(dateString)

  const day = date.getDate()
  const monthIndex = date.getMonth()
  const year = date.getFullYear()

  if (monthDay) {
    return `${monthIndex < 10 ? '0' : ''}${monthIndex + 1}/${
      day < 10 ? '0' : ''
    }${day}`
  }

  return `${
    fullName ? monthNames[monthIndex] : monthNames[monthIndex].substr(0, 3)
  } ${day}, ${year}`
}

export const timeFormat = (timeValue, withSec = false) => {
  let timeString = timeValue

  if (typeof timeString === 'string') {
    timeString = timeString.replace(/\s/, 'T')
  }

  if (!timeValue) {
    return ''
  }

  const time = new Date(`${timeString}+08:00`)

  if (!time) {
    return ''
  }

  let hour = time.getHours()
  let minutes = time.getMinutes()
  let seconds = time.getSeconds()
  let ampm = 'AM'

  if (hour >= 12) {
    ampm = 'PM'
  }

  if (hour > 12) {
    hour -= 12
  }

  if (hour === 0) {
    hour = 12
  }

  if (minutes < 10) {
    minutes = `0${minutes}`
  }

  if (seconds < 10) {
    seconds = `0${seconds}`
  }

  return `${hour}:${minutes}${withSec ? `:${seconds}` : ''} ${ampm}`
}

export const dateTimeFormat = (dateTimeString, withSec = false) =>
  `${dateFormat(dateTimeString)} ${timeFormat(dateTimeString, withSec)}`

export const loungeFormat = date => {
  const day = date.getDate()
  const monthIndex = date.getMonth()
  const year = date.getFullYear()
  const hour24 = date.getHours()
  const isPm = hour24 >= 12
  const hour12 = hour24 % 12
  const hour = hour12 === 0 ? 12 : hour12
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return `${monthNames[monthIndex].slice(
    0,
    3,
  )} ${day}, ${year} | ${hour}:${minute
    .toString()
    .padStart(2, '0')}:${second.toString().padStart(2, '0')} ${
    isPm ? 'PM' : 'AM'
  }`
}

export const getCurrentTimeStamp = () => {
  return new Date().toISOString()
}
export const isDateNow = dateString =>
  dateFormat(dateString) === dateFormat(new Date())

export default dateFormat
